import React from 'react';
import { Skeleton } from '../UI';

const PageLoader: React.FC = () => (
  <div className="page-loader" aria-busy="true" aria-label="Loading">
    <div>
      <Skeleton width="22rem" height="2.8rem" />
      <div style={{ height: '1rem' }} />
      <Skeleton width="36rem" height="1.4rem" />
    </div>
    <div className="grid grid--kpi">
      {[0, 1, 2, 3].map((i) => (
        <div className="kpi" key={i}>
          <Skeleton width="12rem" />
          <Skeleton width="8rem" height="3rem" />
        </div>
      ))}
    </div>
    <div className="panel">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div key={i} style={{ padding: '1rem 0' }}>
          <Skeleton width={`${60 + ((i * 13) % 35)}%`} />
        </div>
      ))}
    </div>
  </div>
);

export default PageLoader;
